import { Component, OnInit, AfterViewInit, AfterContentInit, OnDestroy, inject } from '@angular/core';

import { PlatformService } from '@core/services/util/platform.service';
import { DeviceService } from '@core/services/util/device.service';

import { StaticText } from '@project_app/config/static.text';
import { environment } from '@environment';

@Component({
    selector: 'app-base',
    template: '',
    standalone: true,
})

export class BaseComponent implements OnInit, AfterViewInit, AfterContentInit, OnDestroy {

    isServer = true;
    isBrowser = false;
    isMobile = false;
    isAndroid = true;

    DEPLOY_URL: string;

    staticText = {...StaticText, brandName: environment.brand.name};

	public platformService: PlatformService = inject(PlatformService);
	public deviceService: DeviceService = inject(DeviceService);

    constructor() {
        this.isServer = this.platformService.isServer();
        this.isBrowser = this.platformService.isBrowser();
        this.isAndroid = this.platformService.isAndroid();
        this.isMobile = this.deviceService.isMobile();
        
        this.DEPLOY_URL = environment.DEPLOY_URL;
    }

    ngOnInit() {
        if (this.isBrowser) this.ngOnInitBrowser();
        if (this.isServer) this.ngOnInitServer();
    }

    ngOnInitBrowser() {
        // Override it inside of component for implementation of ngOnInit on Browser
    }
    ngOnInitServer() {
        // Override it inside of component for implementation of ngOnInit on Server
    }

    ngAfterViewInit() {
        if (this.isBrowser) this.ngAfterViewInitBrowser();
        if (this.isServer) this.ngAfterViewInitServer();
    }
    ngAfterViewInitBrowser() {
        // Override it inside of component for implementation of ngAfterViewInit on Browser
    }
    ngAfterViewInitServer() {
        // Override it inside of component for implementation of ngAfterViewInit on server
    }

    ngAfterViewChecked() {
        if (this.isBrowser) this.ngAfterViewCheckedBrowser();
        if (this.isServer) this.ngAfterViewCheckedServer();
    }
    ngAfterViewCheckedBrowser() {
        // Override it inside of component for implementation of ngAfterViewInit on Browser
    }
    ngAfterViewCheckedServer() {
        // Override it inside of component for implementation of ngAfterViewInit on server
    }

    ngAfterContentInit() {
        if (this.isBrowser) this.ngAfterContentInitBrowser();
        if (this.isServer) this.ngAfterContentInitServer();
    }
    ngAfterContentInitBrowser() {
        // Override it inside of component for implementation of ngAfterContentInit on Browser
    }
    ngAfterContentInitServer() {
        // Override it inside of component for implementation of ngAfterContentInit on server
    }

    ngOnDestroy() {
        if (this.isBrowser) this.ngOnDestroyBrowser();
        if (this.isServer) this.ngOnDestroyServer();
    }
    ngOnDestroyBrowser() {
        // Override it inside of component for implementation of ngOnDestroy on Browser
    }
    ngOnDestroyServer() {
        // Override it inside of component for implementation of ngOnDestroy on server
    }
}
